export const ASSETMOCK  =
    [
        {
          name: "414845",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1657643291,
            longitude: -85.7287647855,
            altitude: 142,
            speed: 0,
            heading: 120
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:11:01.932Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414846",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.166802763,
            longitude: -85.7294419595,
            altitude: 151,
            speed: 0,
            heading: 91
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: null
          },
          updateTimestamp: "2021-06-06T04:03:00.030Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414847",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.2179532433,
            longitude: -85.2324765735,
            altitude: 245,
            speed: 0,
            heading: 165
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:03:00.262Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414848",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1634598924,
            longitude: -85.5544475187,
            altitude: 197,
            speed: 0,
            heading: 123
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:03:00.471Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414849",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1665271242,
            longitude: -85.7288683859,
            altitude: 146,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false
          },
          updateTimestamp: "2021-06-06T04:03:00.675Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414850",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1665878091,
            longitude: -85.7295080927,
            altitude: 148,
            speed: 0,
            heading: 105
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:09:03.610Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414865",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1666646712,
            longitude: -85.7291475871,
            altitude: 149,
            speed: 0,
            heading: 331
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: null
          },
          updateTimestamp: "2021-06-06T04:03:00.886Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414866",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1666379748,
            longitude: -85.7294660994,
            altitude: 144,
            speed: 0,
            heading: 202
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: null
          },
          updateTimestamp: "2021-06-06T04:05:00.703Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414867",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1658327254,
            longitude: -85.7287286595,
            altitude: 139,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:01:04.058Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414894",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.166403533,
            longitude: -85.7291387861,
            altitude: 161,
            speed: 0,
            heading: 2
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:11:02.164Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414895",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1664869748,
            longitude: -85.7292030753,
            altitude: 142,
            speed: 0,
            heading: 336
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: null
          },
          updateTimestamp: "2021-06-06T04:05:00.923Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414896",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1667145435,
            longitude: -85.7291294821,
            altitude: 150,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:15:08.009Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414897",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1658069929,
            longitude: -85.7287299168,
            altitude: 143,
            speed: 0,
            heading: 247
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:07:00.276Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414898",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1665986637,
            longitude: -85.7292116248,
            altitude: 146,
            speed: 0,
            heading: 293
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:11:02.368Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "414899",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1674130494,
            longitude: -85.7318801713,
            altitude: 147,
            speed: 0,
            heading: 99
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 185053,
            onBreak: false,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:09:03.818Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "416355",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1658575777,
            longitude: -85.7286855765,
            altitude: 142,
            speed: 1,
            heading: 33
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:09:04.034Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "419679",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1671976345,
            longitude: -85.7306661364,
            altitude: 140,
            speed: 5,
            heading: 293
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:07:00.480Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "419680",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1666812674,
            longitude: -85.729206428,
            altitude: 144,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:07:00.685Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "419681",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1663171994,
            longitude: -85.7290398796,
            altitude: 140,
            speed: 0,
            heading: 118
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:05:01.128Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "419682",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1667692773,
            longitude: -85.7291670331,
            altitude: 152,
            speed: 0,
            heading: 107
          },
          metadata: {
            driverName: "D. Ellsworth",
            driverId: "lsb4cwr",
            driverInitials: "SMH",
            vanColor: "#ff00ff",
            vanFontColor: "#000000",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:15:14.000Z",
          updatedBy: "lsb4cwr",
          active: true
        },
        {
          name: "419683",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.163261828,
            longitude: -85.7216963266,
            altitude: 143,
            speed: 9,
            heading: 4
          },
          metadata: {
            driverName: "J. Ollis",
            driverId: "zjd3qqj",
            driverInitials: "JLO",
            vanColor: "#351C15",
            vanFontColor: "#E19D03",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:15:18.000Z",
          updatedBy: "zjd3qqj",
          active: true
        },
        {
          name: "419684",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1658999063,
            longitude: -85.72868214,
            altitude: 141,
            speed: 0,
            heading: 104
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:11:02.575Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "419685",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1893849616,
            longitude: -85.7398285897,
            altitude: 146,
            speed: 27,
            heading: 85
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:12:59.656Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "419686",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1659569033,
            longitude: -85.728564458,
            altitude: 154,
            speed: 0,
            heading: 201
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:01:04.265Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "419687",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1667480711,
            longitude: -85.7294911613,
            altitude: 146,
            speed: 0,
            heading: 86
          },
          metadata: {
            driverName: "L. Aivatzidis",
            driverId: "jyp6sxh",
            driverInitials: "LEO",
            vanColor: "#99ccff",
            vanFontColor: "#000080",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:15:14.000Z",
          updatedBy: "jyp6sxh",
          active: true
        },
        {
          name: "419688",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1667042757,
            longitude: -85.7292462421,
            altitude: 152,
            speed: 0,
            heading: 116
          },
          metadata: {
            driverName: "D. Lunsford",
            driverId: "dlg6cxq",
            driverInitials: "DAV",
            vanColor: "#000000",
            vanFontColor: "#ffffff",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:15:25.000Z",
          updatedBy: "dlg6cxq",
          active: true
        },
        {
          name: "419689",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1667118194,
            longitude: -85.7301533316,
            altitude: 149,
            speed: 0,
            heading: 111
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:15:08.235Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "829916",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1664118311,
            longitude: -85.7291390375,
            altitude: 159,
            speed: 0,
            heading: 152
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:11:02.781Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "829917",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1634322748,
            longitude: -85.554340304,
            altitude: 191,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:05:01.331Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "829918",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1635330338,
            longitude: -85.5544494284,
            altitude: 191,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:05:01.535Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "Rental 1",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1660216535,
            longitude: -85.7286314295,
            altitude: 142,
            speed: 0,
            heading: 107
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:05:01.741Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "Rental 2",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1659949258,
            longitude: -85.7271195102,
            altitude: 144,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "K. Lyles",
            driverId: "srj2vfg",
            driverInitials: "KRL",
            vanColor: "#000000",
            vanFontColor: "#ff0000",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:15:23.000Z",
          updatedBy: "srj2vfg",
          active: true
        },
        {
          name: "Rental 3",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.179422305,
            longitude: -85.7209280413,
            altitude: 153,
            speed: 18,
            heading: 173
          },
          metadata: {
            driverName: "C. Oblisk",
            driverId: "fnr1ztc",
            driverInitials: "CCO",
            vanColor: "#ff6600",
            vanFontColor: "#00ff00",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:15:18.000Z",
          updatedBy: "fnr1ztc",
          active: true
        },
        {
          name: "Rental 4",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1658997387,
            longitude: -85.7286071219,
            altitude: 149,
            speed: 0,
            heading: 325
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:07:00.890Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "Rental 5",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1658947096,
            longitude: -85.728672417,
            altitude: 146,
            speed: 0,
            heading: 91
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:09:04.244Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "Rental 6",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1660474697,
            longitude: -85.7286897675,
            altitude: 138,
            speed: 0,
            heading: 105
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:15:08.440Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "Rental 7",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1656785822,
            longitude: -85.7285726723,
            altitude: 143,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:07:01.100Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "Rental 8",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 0,
            longitude: 0,
            altitude: 151,
            speed: 2,
            heading: 45
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: null,
            breakTime: null
          },
          updateTimestamp: "2021-06-06T04:05:01.952Z",
          updatedBy: "inactivityAudit",
          active: true
        },
        {
          name: "Rental 9",
          owner: "CREWVAN",
          assetTypeName: "Van",
          position: {
            locationName: "sdf",
            latitude: 38.1656785822,
            longitude: -85.7285726723,
            altitude: 143,
            speed: 0,
            heading: 0
          },
          metadata: {
            driverName: "",
            driverId: "",
            driverInitials: "UPS",
            vanColor: "brown",
            vanFontColor: "gold",
            passengerCount: 0,
            nextAssignmentStartTime: "",
            vanStatus: "",
            accuracy: 99,
            onBreak: false,
            breakTime: ""
          },
          updateTimestamp: "2021-06-06T04:01:04.473Z",
          updatedBy: "inactivityAudit",
          active: true
        }
      ];


